import { jsxs as i, jsx as l } from "react/jsx-runtime";
const h = (t) => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ...t,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#4285F4",
          d: "M5.636 25.005h3.819v-9.273L4 11.64v11.727c0 .906.734 1.637 1.636 1.637"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#34A853",
          d: "M22.546 25.005h3.818c.905 0 1.636-.734 1.636-1.637V11.641l-5.454 4.09"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#FBBC04",
          d: "M22.546 8.641v7.09L28 11.642V9.459c0-2.023-2.31-3.177-3.927-1.963"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#EA4335",
          d: "M9.455 15.732V8.64L16 13.551l6.546-4.91v7.09L16 20.642"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#C5221F",
          d: "M4 9.46v2.181l5.455 4.09v-7.09L7.927 7.496C6.307 6.282 4 7.436 4 9.459"
        }
      )
    ]
  }
);
export {
  h as default
};
